var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9, _path10, _g10, _path11, _g11, _path12, _g12, _path13, _g13, _path14, _g14, _path15, _g15, _path16, _g16, _path17, _g17, _path18, _g18, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompliaceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_481)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_22_481",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 68,
    height: 68
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69 1H1V69H69V1Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_22_481)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 14.8519C1 7.20212 7.20212 1 14.8519 1H35C35.6955 1 36.2593 1.56379 36.2593 2.25926C36.2593 2.95473 35.6955 3.51852 35 3.51852H14.8519C8.59306 3.51852 3.51852 8.59306 3.51852 14.8519V35C3.51852 35.6955 2.95473 36.2593 2.25926 36.2593C1.56379 36.2593 1 35.6955 1 35V14.8519Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_22_481",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 68,
    height: 68
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69 1H1V69H69V1Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_22_481)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.7407 33.7407C68.4362 33.7407 69 34.3045 69 35V55.1481C69 62.7979 62.7979 69 55.1481 69H35C34.3045 69 33.7407 68.4362 33.7407 67.7407C33.7407 67.0453 34.3045 66.4815 35 66.4815H55.1481C61.4069 66.4815 66.4815 61.4069 66.4815 55.1481V35C66.4815 34.3045 67.0453 33.7407 67.7407 33.7407Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_22_481",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 68,
    height: 68
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69 1H1V69H69V1Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_22_481)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25926 33.7407C2.95473 33.7407 3.51852 34.3045 3.51852 35V55.1481C3.51852 61.4069 8.59306 66.4815 14.8519 66.4815H35C35.6955 66.4815 36.2593 67.0453 36.2593 67.7407C36.2593 68.4362 35.6955 69 35 69H14.8519C7.20212 69 1 62.7979 1 55.1481V35C1 34.3045 1.56379 33.7407 2.25926 33.7407Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_22_481",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 68,
    height: 68
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69 1H1V69H69V1Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_22_481)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 33.7407C35.6955 33.7407 36.2592 34.3045 36.2592 35V44.8348C36.2592 45.5303 35.6955 46.0941 35 46.0941C34.3045 46.0941 33.7407 45.5303 33.7407 44.8348V35C33.7407 34.3045 34.3045 33.7407 35 33.7407Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_22_481",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 68,
    height: 68
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69 1H1V69H69V1Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_22_481)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 23.9059C35.6955 23.9059 36.2592 24.4697 36.2592 25.1652V35C36.2592 35.6955 35.6955 36.2593 35 36.2593C34.3045 36.2593 33.7407 35.6955 33.7407 35V25.1652C33.7407 24.4697 34.3045 23.9059 35 23.9059Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_22_481",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 68,
    height: 68
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69 1H1V69H69V1Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_22_481)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 56.6467C35.6955 56.6467 36.2592 57.2105 36.2592 57.9059V67.7407C36.2592 68.4362 35.6955 69 35 69C34.3045 69 33.7407 68.4362 33.7407 67.7407V57.9059C33.7407 57.2105 34.3045 56.6467 35 56.6467Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_22_481",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 68,
    height: 68
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M69 1H1V69H69V1Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_22_481)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 1C35.6955 1 36.2592 1.56379 36.2592 2.25926V12.0941C36.2592 12.7895 35.6955 13.3533 35 13.3533C34.3045 13.3533 33.7407 12.7895 33.7407 12.0941V2.25926C33.7407 1.56379 34.3045 1 35 1Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_22_481",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 68,
    height: 68
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69 1H1V69H69V1Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_22_481)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9059 35C23.9059 34.3045 24.4697 33.7407 25.1651 33.7407H35C35.6954 33.7407 36.2592 34.3045 36.2592 35C36.2592 35.6955 35.6954 36.2593 35 36.2593H25.1651C24.4697 36.2593 23.9059 35.6955 23.9059 35Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_22_481",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 68,
    height: 68
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M69 1H1V69H69V1Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_22_481)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 35C1 34.3045 1.56379 33.7407 2.25926 33.7407H12.0941C12.7895 33.7407 13.3533 34.3045 13.3533 35C13.3533 35.6955 12.7895 36.2593 12.0941 36.2593H2.25926C1.56379 36.2593 1 35.6955 1 35Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_22_481",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 68,
    height: 68
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M69 1H1V69H69V1Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_22_481)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.6466 35C56.6466 34.3045 57.2104 33.7407 57.9059 33.7407H67.7407C68.4362 33.7407 68.9999 34.3045 68.9999 35C68.9999 35.6955 68.4362 36.2593 67.7407 36.2593H57.9059C57.2104 36.2593 56.6466 35.6955 56.6466 35Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_22_481",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 68,
    height: 68
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M69 1H1V69H69V1Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_22_481)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7407 35C33.7407 34.3045 34.3045 33.7407 35 33.7407H44.8348C45.5303 33.7407 46.0941 34.3045 46.0941 35C46.0941 35.6955 45.5303 36.2593 44.8348 36.2593H35C34.3045 36.2593 33.7407 35.6955 33.7407 35Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_22_481",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 68,
    height: 68
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M69 1H1V69H69V1Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_22_481)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4073 51.3704C22.4073 46.5039 26.3519 42.5556 31.2222 42.5556C32.8328 42.5556 34.3375 42.9939 35.6323 43.7459C36.2337 44.0951 36.4382 44.8658 36.0889 45.4672C35.7396 46.0686 34.969 46.273 34.3675 45.9238C33.4398 45.385 32.3693 45.0741 31.2222 45.0741C27.7435 45.0741 24.9259 47.8942 24.9259 51.3704C24.9259 54.8493 27.7432 57.6667 31.2222 57.6667C32.3693 57.6667 33.4398 57.3557 34.3675 56.817C34.969 56.4677 35.7396 56.6721 36.0889 57.2735C36.4382 57.8749 36.2337 58.6456 35.6323 58.9949C34.3375 59.7469 32.8328 60.1852 31.2222 60.1852C26.3522 60.1852 22.4073 56.2403 22.4073 51.3704Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_22_481",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 68,
    height: 68
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M69 1H1V69H69V1Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_22_481)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.4672 33.9111C46.0686 34.2603 46.273 35.031 45.9238 35.6324C45.385 36.5601 45.0741 37.6307 45.0741 38.7778C45.0741 42.2564 47.8942 45.0741 51.3704 45.0741C54.8465 45.0741 57.6667 42.2564 57.6667 38.7778C57.6667 37.6307 57.3557 36.5601 56.817 35.6324C56.4677 35.031 56.6721 34.2603 57.2735 33.9111C57.8749 33.5618 58.6456 33.7662 58.9949 34.3676C59.7468 35.6625 60.1852 37.1671 60.1852 38.7778C60.1852 43.648 56.2368 47.5926 51.3704 47.5926C46.5039 47.5926 42.5555 43.648 42.5555 38.7778C42.5555 37.1671 42.9939 35.6625 43.7459 34.3676C44.0951 33.7662 44.8658 33.5618 45.4672 33.9111Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_22_481",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 68,
    height: 68
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M69 1H1V69H69V1Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_22_481)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3676 11.0051C35.6624 10.2531 37.1671 9.81482 38.7777 9.81482C43.6445 9.81482 47.5925 13.7629 47.5925 18.6296C47.5925 23.4964 43.6445 27.4445 38.7777 27.4445C37.1671 27.4445 35.6624 27.0061 34.3676 26.2541C33.7661 25.9049 33.5617 25.1342 33.911 24.5328C34.2603 23.9314 35.0309 23.727 35.6323 24.0762C36.5601 24.615 37.6306 24.9259 38.7777 24.9259C42.2535 24.9259 45.074 22.1055 45.074 18.6296C45.074 15.1538 42.2535 12.3333 38.7777 12.3333C37.6306 12.3333 36.5601 12.6443 35.6323 13.183C35.0309 13.5323 34.2603 13.3279 33.911 12.7265C33.5617 12.1251 33.7661 11.3544 34.3676 11.0051Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_22_481",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 68,
    height: 68
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M69 1H1V69H69V1Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_22_481)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.81482 31.2222C9.81482 26.3555 13.7629 22.4074 18.6296 22.4074C23.4964 22.4074 27.4445 26.3555 27.4445 31.2222C27.4445 32.8329 27.0061 34.3375 26.2541 35.6324C25.9049 36.2338 25.1342 36.4382 24.5328 36.089C23.9314 35.7397 23.727 34.969 24.0762 34.3676C24.615 33.4399 24.9259 32.3693 24.9259 31.2222C24.9259 27.7464 22.1055 24.9259 18.6296 24.9259C15.1538 24.9259 12.3333 27.7464 12.3333 31.2222C12.3333 32.3693 12.6443 33.4399 13.183 34.3676C13.5323 34.969 13.3279 35.7397 12.7265 36.089C12.1251 36.4382 11.3544 36.2338 11.0051 35.6324C10.2531 34.3375 9.81482 32.8329 9.81482 31.2222Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_22_481",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 68,
    height: 68
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M69 1H1V69H69V1Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_22_481)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7407 2.25926C33.7407 1.56379 34.3045 1 35 1H38.7778C39.4732 1 40.037 1.56379 40.037 2.25926C40.037 2.95473 39.4732 3.51852 38.7778 3.51852H35C34.3045 3.51852 33.7407 2.95473 33.7407 2.25926Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_22_481",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 68,
    height: 68
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M69 1H1V69H69V1Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_22_481)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.0205 2.25926C45.0205 1.56379 45.5843 1 46.2798 1H48.4969C49.1923 1 49.7561 1.56379 49.7561 2.25926C49.7561 2.95473 49.1923 3.51852 48.4969 3.51852H46.2798C45.5843 3.51852 45.0205 2.95473 45.0205 2.25926ZM51.6718 2.25926C51.6718 1.56379 52.2355 1 52.931 1H55.1481C57.0239 1 58.8157 1.37363 60.4507 2.0517C61.0931 2.31813 61.3979 3.05489 61.1315 3.6973C60.8651 4.33971 60.1283 4.64452 59.4859 4.37809C58.1514 3.82462 56.687 3.51852 55.1481 3.51852H52.931C52.2355 3.51852 51.6718 2.95473 51.6718 2.25926ZM66.3027 8.86844C66.9451 8.60202 67.6818 8.90682 67.9482 9.54923C68.6263 11.1842 69 12.976 69 14.8519V18.0071C69 18.7026 68.4362 19.2663 67.7407 19.2663C67.0452 19.2663 66.4814 18.7026 66.4814 18.0071V14.8519C66.4814 13.3129 66.1753 11.8486 65.6219 10.514C65.3554 9.87163 65.6602 9.13487 66.3027 8.86844ZM67.7407 23.0583C68.4362 23.0583 69 23.6221 69 24.3175V27.4728C69 28.1682 68.4362 28.732 67.7407 28.732C67.0452 28.732 66.4814 28.1682 66.4814 27.4728V24.3175C66.4814 23.6221 67.0452 23.0583 67.7407 23.0583Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_22_481",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 68,
    height: 68
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M69 1H1V69H69V1Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_22_481)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.7407 29.963C68.4362 29.963 69 30.5268 69 31.2222V35C69 35.6955 68.4362 36.2593 67.7407 36.2593C67.0452 36.2593 66.4814 35.6955 66.4814 35V31.2222C66.4814 30.5268 67.0452 29.963 67.7407 29.963Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompliaceIcon);
export default __webpack_public_path__ + "static/media/compliace-icon.fba6021833b169e05611ff55c5808b38.svg";
export { ForwardRef as ReactComponent };